import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";

import api from "@/services/api";

export default function Brief({ job, setJob }) {
  const { id } = useParams();
  const [value, setValue] = useState(job?.brief || "");
  const [saving, setSaving] = useState(false);
  const textareaRef = useRef(null);

  const isDirty = value !== (job?.brief || "");

  useEffect(() => {
    const el = textareaRef.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight}px`;
  }, [value]);

  const handleSave = async () => {
    if (!isDirty) return;
    setSaving(true);
    try {
      const { ok, data } = await api.put(`/job/${id}`, { brief: value });
      if (!ok) return toast.error("Failed to save brief");
      setJob(data);
      toast.success("Brief saved");
    } catch (e) {
      console.error(e);
      toast.error("Failed to save brief");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="container mx-auto max-w-4xl space-y-4 p-6 pb-20">
      <div>
        <div className="mb-2">
          <label className="text-sm font-medium text-gray-700 block">Brief</label>
          <p className="text-xs text-gray-500">What are you looking for? Context, must-haves, nice-to-haves. Internal only.</p>
        </div>
        <textarea
          ref={textareaRef}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          rows={8}
          placeholder="e.g. We're hiring a senior data scientist to lead the RAG team. Must-have: 5+ years Python, LLM experience, good written English. Bonus: finance domain."
          className="input w-full font-mono text-sm leading-relaxed resize-none overflow-hidden"
        />
        <div className="flex justify-end mt-3">
          <button
            type="button"
            onClick={handleSave}
            disabled={!isDirty || saving}
            className="btn btn-primary disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {saving ? "Saving…" : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}
